import { Thunk } from 'ha/myredux/types';
import { Actions } from '../constants';

const initialize =
  ({ params }: { params: any }): Thunk =>
  (dispatch, _, services) => {
    dispatch({
      type: Actions.INITIALIZE,
      payload: params,
      error: false,
    });

    return services.facebook.init();
  };

export { initialize };
